/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NewPwAliases {
  BUTTON_ACCESS_ACCOUNT = 'button-access-account',
  BUTTON_CREATE_NEW_PW = 'button-create-new-pw',
  FIELD_CONFIRM_NEW_PW = 'field-confirm-new-pw',
  FIELD_NEW_PW = 'field-new-pw',
  FORM_NEW_PW = 'form-new-pw',
  IMAGE_0 = 'image-0',
  IMAGE_LOGO = 'image-logo',
  INPUT_CONFIRM_NEW_PW = 'input-confirm-new-pw',
  INPUT_NEW_PW = 'input-new-pw',
  LAYOUT_0 = 'layout-0',
  LAYOUT_1 = 'layout-1',
  LAYOUT_2 = 'layout-2',
  LAYOUT_NEW_PW = 'layout-new-pw',
  LOADER_0 = 'loader-0',
  PANEL_0 = 'panel-0',
  PANEL_2 = 'panel-2',
  PANEL_4 = 'panel-4',
  PANEL_5 = 'panel-5',
  PANEL_6 = 'panel-6',
  PANEL_7 = 'panel-7',
  PANEL_ACTIONS = 'panel-actions',
  PANEL_LOADER = 'panel-loader',
  PANEL_SCREEN = 'panel-screen',
  PANEL_SUCCESS = 'panel-success',
  PANEL_TITLE = 'panel-title',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_MESSAGE = 'text-message',
  TEXT_TITLE = 'text-title',
}
export { NewPwAliases };
